import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["active", "images", "close", "previous", "next", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useTheme } from '@emotion/react';
import { forwardRef } from 'react';
import { AnimatePresence } from 'framer-motion';
import { transparentize } from 'polished';
import { ClearIcon, ArrowLeft, ArrowRight } from '@segment/matcha/components/Icons/Common';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './Lightbox.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
var animationState = {
  initial: {
    position: "relative",
    opacity: 0
  },
  animate: {
    opacity: 1,
    transition: {
      duration: 0.75
    }
  },
  exit: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    opacity: 0,
    transition: {
      duration: 0.2
    }
  }
};
var SWIPE_CONFIDENCE_THRESHOLD = 10000;

var swipePower = function swipePower(offset, velocity) {
  return Math.abs(offset) * velocity;
};

var BaseLightbox = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var active = _ref.active,
      images = _ref.images,
      close = _ref.close,
      previous = _ref.previous,
      next = _ref.next,
      tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();
  return _jsxs(views.Lightbox, _objectSpread(_objectSpread(_objectSpread({}, tokens), rest), {}, {
    ref: ref,
    children: [_jsx(views.Dimmer, {}), _jsxs(views.Container, {
      children: [close && _jsx(views.Close, {
        onClick: close,
        children: _jsx(ClearIcon, {
          size: "large",
          color: theme.palette.neutrals.white[100]
        })
      }), images && (images === null || images === void 0 ? void 0 : images.length) > 0 && _jsxs(views.Counter, {
        children: [active + 1, " / ", images === null || images === void 0 ? void 0 : images.length]
      }), _jsx(views.MediaArea, {
        children: _jsx(AnimatePresence, {
          initial: false,
          children: images && _jsx(views.Images, {
            drag: "x",
            dragConstraints: {
              left: 0,
              right: 0
            },
            dragMomentum: false,
            onDragEnd: function onDragEnd(_e, _ref2) {
              var offset = _ref2.offset,
                  velocity = _ref2.velocity;
              var swipe = swipePower(offset.x, velocity.x);

              if (swipe < -SWIPE_CONFIDENCE_THRESHOLD && next) {
                next();
              } else if (swipe > SWIPE_CONFIDENCE_THRESHOLD && previous) {
                previous();
              }
            },
            children: _jsx(views.Media, _objectSpread(_objectSpread({}, animationState), {}, {
              src: images[active].src
            }), images[active].src)
          })
        })
      }), images && (images === null || images === void 0 ? void 0 : images.length) > 0 && _jsxs(_Fragment, {
        children: [active !== 0 && previous && _jsx(views.Arrow, {
          onClick: previous,
          children: _jsx(ArrowLeft, {
            color: theme.palette.neutrals.white[100],
            size: "medium"
          })
        }), active + 1 !== (images === null || images === void 0 ? void 0 : images.length) && next && _jsx(views.Arrow, {
          right: true,
          onClick: next,
          children: _jsx(ArrowRight, {
            color: theme.palette.neutrals.white[100],
            size: "medium"
          })
        })]
      }), _jsx(views.CaptionContainer, {
        children: _jsx(AnimatePresence, {
          initial: false,
          children: images && _jsx(views.Caption, _objectSpread(_objectSpread({}, animationState), {}, {
            children: images[active].caption
          }), images[active].src)
        })
      })]
    })]
  }));
});
export var Lightbox = withDesignTokens(BaseLightbox, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      dimmerBackground: transparentize(0.1, theme.palette.brand.darkAcai[700]),
      counterColor: theme.palette.neutrals.white[100],
      captionColor: theme.palette.neutrals.white[100],
      arrowBackground: transparentize(0.5, "#321F46")
    };
  },
  dark: function dark(theme) {
    return {
      dimmerBackground: transparentize(0.1, theme.palette.brand.darkAcai[700]),
      counterColor: theme.palette.neutrals.white[100],
      captionColor: theme.palette.neutrals.white[100],
      arrowBackground: transparentize(0.5, "#321F46")
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      dimmerBackground: transparentize(0.1, theme.palette.twilio.gray[100]),
      counterColor: theme.palette.neutrals.white[100],
      captionColor: theme.palette.neutrals.white[100],
      arrowBackground: transparentize(0.5, theme.palette.twilio.gray[60])
    };
  }
});